import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "product/feature"

class service {

    selectList(params) {
        return http.list(path + "/selectList",params);
    }

    getForceReadById(id){
        return http.getById(path,id,true).then(response => response.data);
    }

    getFeaturesByGroupProductId(groupProductId) {

        if (groupProductId > 0) {

            let params = new URLSearchParams()
            params.set("grouped", "true")
            params.set("groupProductId", groupProductId)
            return http.list(path + "/getAllByGroupProductId",params);

        }
    }


}

export default new service();

